import { Component, ElementRef, ViewChild, inject, Input } from "@angular/core";
import {
  CommonModule,
  IMAGE_LOADER,
  ImageLoaderConfig,
  NgOptimizedImage,
} from "@angular/common";
import { ScrollAnchorDirective } from "../../utils/directives/scroll-anchor.directive";
import { AssetFile } from "contentful";
import { TypeHeroSectionFields } from "../../../models/contentful-content-types/hero-section.model";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { ButtonComponent } from "../button/button.component";

@Component({
  imports: [
    CommonModule,
    ScrollAnchorDirective,
    NgOptimizedImage,
    ButtonComponent,
  ],
  providers: [
    {
      provide: IMAGE_LOADER,
      useValue: (config: ImageLoaderConfig) => {
        return `https://images.ctfassets.net/${config.src}?w=${config.width}`;
      },
    },
  ],
  selector: "jnguyen-hero-section",
  templateUrl: "./hero-section.component.html",
  styleUrls: ["./hero-section.component.scss"],
})
export class HeroSectionComponent {
  @Input() data: TypeHeroSectionFields;
  @ViewChild("heroVideo") heroVideo?: ElementRef<HTMLVideoElement>;

  documentToHtmlString = documentToHtmlString;

  private sanitizer = inject(DomSanitizer);
  getImageUrl(url: string | AssetFile) {
    if (typeof url === "string") {
      const cutUrl = url.replace(/\/\/images\.ctfassets\.net\//, "");
      return `${cutUrl}`;
    }
  }
  // ✅ Hero-Video-URL mit Sanitizer
  heroVideoUrl(): SafeResourceUrl | null {
    const url = this.data?.heroVideo?.fields?.file?.url;
    if (!url || typeof url !== "string") return null;
    const fullUrl = url.startsWith("https") ? url : `https:${url}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
  }

  // ✅ Chrome- & Safari-freundliches Autoplay
}
